import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useMemo, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { switchRole } from "../auth/login/loginSlice";
import { useGetRolesQuery } from "../upload/dataAccess";
import { useSnackbar } from "notistack";
import useQueryParams from "../../hooks/useQueryParams/useQueryParams";
import { useGetUserDataQuery } from "../auth/dataAccess";
import useRoles, { Role } from "../permissions/useRoles";
import { useHistory } from "react-router-dom";

const RolesDropdown = () => {
    const { userActiveRole, switchRole } = useRoles();

    const { enqueueSnackbar } = useSnackbar();

    const { data: user } = useGetUserDataQuery();
    const { data: roles } = useGetRolesQuery(user?.userID ?? "");

    const handleChangeRole = async (e: any) => {
        const selectedNewRole = e.target.value as Role;
        try {
            await switchRole(selectedNewRole);
        } catch (e) {
            enqueueSnackbar("Something wrong happened.", {
                variant: "error",
            });
        }
    };

    const renderRoleItem = (role: string) => {
        return (
            <FormControlLabel
                key={role}
                value={role}
                control={
                    <Radio
                        size="small"
                        sx={{
                            padding: "4px",
                            marginRight: "8px",
                        }}
                    />
                }
                label={role === "Master Admin" ? "System Admin" : role}
                sx={{
                    "& .MuiFormControlLabel-label": {
                        fontSize: "0.875rem",
                        fontWeight: userActiveRole === role ? "500" : "400",
                    },
                    "margin": "0",
                    "padding": "4px 0",
                    "height": "32px",
                    "width": "100%",
                }}
            />
        );
    };

    const RoleItems = useMemo(() => {
        if (!roles) return;
        return roles.roles.map(renderRoleItem);
    }, [roles]);

    return roles && roles.roles.length > 1 ? (
        <FormControl sx={{ width: "100%" }}>
            <RadioGroup
                aria-labelledby="role-radio-buttons-group-label"
                defaultValue={userActiveRole ?? ""}
                onChange={handleChangeRole}
                name="radio-buttons-group"
                value={userActiveRole}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    ml: 0.5,
                }}
            >
                {RoleItems}
            </RadioGroup>
        </FormControl>
    ) : null;
};

export default RolesDropdown;
